import * as z from 'zod';

import { urlSchema } from '@/_schemas/generic';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { registrarQuerySchema } from './registrar-query-schema';

export const registrarFormSchema = registrarQuerySchema
  .omit({
    name: true,
    url: true,
    notes: true,
    phone_numbers: true,
    domains_count: true,
  })
  .extend({
    name: z.string().min(3),
    url: urlSchema(),
    notes: z.string(),
    phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  });

export type RegistrarFormSchema = z.infer<typeof registrarFormSchema>;
